import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const navItems = [
  { path: '/dashboard',       icon: '📊', label: 'Dashboard' },
  { path: '/orders', icon: '📦', label: 'Orders' },
  { path: '/riders', icon: '🏍️', label: 'Drivers' },
  { path: '/map',    icon: '🗺️', label: 'Live Map' },
  { path: '/settings', icon: '⚙️', label: 'Settings' },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = async () => {
    try {
      await api.post('/logout');
    } catch (e) {}
    logout();
    navigate('/login');
  };

  return (
    <div className="flex h-screen bg-gray-100">

      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'w-64' : 'w-16'} bg-primary text-white flex flex-col transition-all duration-300`}>

        {/* Logo */}
        <div className="flex items-center gap-3 p-4 border-b border-blue-700">
          <span className="text-2xl">🚚</span>
          {sidebarOpen && (
            <div>
              <div className="font-bold text-lg">TumaTrack</div>
              <div className="text-blue-200 text-xs">Admin Panel</div>
            </div>
          )}
        </div>

        {/* Nav */}
        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition
                ${location.pathname === item.path
                  ? 'bg-white text-primary font-semibold'
                  : 'text-blue-100 hover:bg-blue-700'
                }`}
            >
              <span className="text-xl">{item.icon}</span>
              {sidebarOpen && <span>{item.label}</span>}
            </Link>
          ))}
        </nav>

        {/* User */}
        <div className="p-3 border-t border-blue-700">
          <div className={`flex items-center gap-3 px-3 py-2 ${sidebarOpen ? '' : 'justify-center'}`}>
            <div className="w-8 h-8 bg-white text-primary rounded-full flex items-center justify-center font-bold flex-shrink-0">
              {(user?.name || 'A')[0].toUpperCase()}
            </div>
            {sidebarOpen && (
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate">{user?.name}</div>
                <div className="text-blue-200 text-xs">{user?.role}</div>
              </div>
            )}
          </div>
          <button
            onClick={handleLogout}
            className={`mt-2 flex items-center gap-2 w-full px-3 py-2 rounded-lg text-blue-100 hover:bg-blue-700 transition text-sm ${!sidebarOpen ? 'justify-center' : ''}`}
          >
            <span>🚪</span>
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col overflow-hidden">

        {/* Topbar */}
        <header className="bg-white shadow-sm px-6 py-4 flex items-center gap-4">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="text-gray-500 hover:text-primary transition"
          >
            ☰
          </button>
          <h1 className="text-xl font-semibold text-gray-800">
            {navItems.find(n => n.path === location.pathname)?.label || 'TumaTrack'}
          </h1>
          <div className="ml-auto text-sm text-gray-500">
            {new Date().toLocaleDateString('en-KE', {
              weekday: 'long', year: 'numeric',
              month: 'long', day: 'numeric'
            })}
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
}